import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .see-more-btn {
    margin-top: 16px;
  }
`

export const StyledArticlesContainer = styled.div`
  margin-top: 0px;

  & > :not(:last-child) {
    margin-bottom: 8px;
  }

  background-color: ${theme.colors.neutral50};
`

export const StyledArticleContainer = styled.div`
  background-color: ${theme.colors.white};

  .banner {
    width: 100%;
    min-height: 192px;
  }

  ${MediaQueries.mbUp} {
    padding: 24px 16px 24px 0;
  }

  ${MediaQueries.mbDown} {
    padding: 24px 0;
  }

  &[data-size='custom'] {
    .avatar[data-size='lg'] {
      width: unset;
      height: unset;
      margin-top: 16px;
      margin-right: 16px;
    }
  }
`

export const StyledSmallArticleContainer = styled.div`
  padding: 16px;

  ${MediaQueries.mbDown} {
    padding: 0;
  }
  background-color: ${theme.colors.white};
`

// desktop layout
export const StyledArticlesDesktopContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  padding: 0;

  background-color: ${theme.colors.white};
  > div {
    width: calc(50% - 8px);
  }
`

export const StyledHeroContainer = styled.div`
  display: flex;
  width: 50%;
  align-self: stretch;
  justify-content: stretch;

  background-color: ${theme.colors.white};

  justify-self: stretch;

  & > div > div {
    height: 100%;
  }

  .banner {
    min-height: 312px;
  }
`

export const StyledSubHeroContainer = styled.div`
  display: flex;
  width: 50%;
  flex-direction: column;
  align-items: stretch;
  align-self: stretch;
  justify-content: center;

  padding-top: 8px;
  background-color: ${theme.colors.white};

  .banner {
    min-height: 150px;
  }

  .content .new .text {
    margin: 6px 0;
  }

  & > :last-child {
    flex: 1;
  }
`

export const StyledSmallArticleDesktopContainer = styled.div`
  padding: 0 0 8px 0;
  background-color: ${theme.colors.neutral50};
  marin-bottom: 8px;

  &[data-size='custom'] {
    .avatar[data-size='md'] {
      width: 40px;
      height: 40px;
      margin-right: 16px;
    }
  }
`

export const StyledHalfScreenDesktopContainer = styled.div`
  width: 50%;
  padding: 0 16px 24px 0;
  background-color: ${theme.colors.white};
  &[data-size='custom'] {
    .avatar[data-size='md'] {
      width: 40px;
      height: 40px;
      margin-right: 16px;
    }
  }
`
export const StyledArticleContainerDesktop = styled.div`
  display: flex;
  flex-wrap: wrap;
`
